// Owner DISPLAY helper — turn an owner reference the projection carries into a short, de-identified avatar
// label for rendering. The board projection references an owner by id; the client surface must expose NO
// internal identifier (G-197), so it never RENDERS the raw ref as text — it derives stable initials from it
// for the avatar tone/label only. When the API resolves a human display name (a later identity-read wiring),
// pass that instead and this derives the initials from it. Deterministic so one owner keeps one avatar.

/** Derive short initials (max two chars) for an owner avatar from whatever ref/name the projection carries. */
export function ownerInitials(ownerRef: string): string {
  // Prefer word initials when the ref looks like a display name ("Dana Ovel" → "DO"); otherwise take the
  // last two alphanumerics of the ref so a plain id still yields a stable, non-identifying two-char label.
  const words = ownerRef
    .trim()
    .split(/[\s._-]+/)
    .filter(Boolean);
  if (words.length >= 2) {
    return (words[0]![0]! + words[1]![0]!).toUpperCase();
  }
  const alnum = ownerRef.replace(/[^a-z0-9]/gi, '');
  if (alnum.length >= 2) return alnum.slice(-2).toUpperCase();
  if (alnum.length === 1) return alnum.toUpperCase();
  return '··';
}
